import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import i18n from '../i18n/config';

const PreferencesProvider = ({ children }) => {
  const user = useSelector((state) => state.auth?.user);
  
  useEffect(() => {
    // We only apply this if user is loaded, otherwise use system defaults
    const prefs = user?.preferences || {};

    // Language Application
    const lang = prefs.language || 'en';
    document.documentElement.lang = lang;

    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }

  }, [user?.preferences]);

  return <>{children}</>;
};

export default PreferencesProvider;
